import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-aktualisieren';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeAktualisierenEffects {

    AufgabeAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_AKTUALISIEREN),
        mergeMap((x: ac.PostAufgabeAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeAktualisieren(x.aufgabeAnlegenRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeAktualisierenErfolgreichAction(result, x.aufgabeAnlegenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeAktualisierenFehlerAction(error, x.aufgabeAnlegenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
